import cn from 'classnames';
import { FC } from 'react';

import type {
  FullHeadMprSliceGroupView,
  FullHeadMprSliceRecordViewsByTileID,
  FullHeadMprSliceTileView,
} from '../../config';
import { useFullHeadMprSliceTileSrcs } from '../../hooks';
import { FullHeadMprSliceImage } from '../FullHeadMprSliceImage';

import styles from './FullHeadMprSliceTileList.module.scss';

type FullHeadMprSliceTileListProps = {
  group: FullHeadMprSliceGroupView;
  hoveredTileID: string;
  pendingTileIDs: string[];
  recordsByTileID: FullHeadMprSliceRecordViewsByTileID;
  className?: string;
  isTileSelected: (tile: FullHeadMprSliceTileView) => boolean;
  onHoveredTileChanged: (tileID: string) => void;
  onToggleTile: (tile: FullHeadMprSliceTileView) => void;
  onZoomTile: (tileID: string) => void;
};

export const FullHeadMprSliceTileList: FC<FullHeadMprSliceTileListProps> = (
  props,
) => {
  const {
    group,
    hoveredTileID,
    pendingTileIDs,
    recordsByTileID,
    className,
    isTileSelected,
    onHoveredTileChanged,
    onToggleTile,
    onZoomTile,
  } = props;

  const { resolveTileSrc } = useFullHeadMprSliceTileSrcs({
    recordsByTileID,
    tiles: group.tiles,
  });

  return (
    <div
      className={cn(styles.container, className)}
      data-component="mpr-slice-tile-list"
      onMouseLeave={() => onHoveredTileChanged('')}
    >
      <div className={styles.tiles}>
        {group.tiles.map((tile) => {
          const isPending = pendingTileIDs.includes(tile.id);

          return (
            <div
              key={tile.id}
              className={cn(
                styles.tileWrapper,
                isPending && styles.pendingTile,
              )}
              onMouseEnter={() => onHoveredTileChanged(tile.id)}
            >
              <FullHeadMprSliceImage
                group={group}
                src={resolveTileSrc(tile)}
                tile={tile}
                record={recordsByTileID[tile.id]}
                selectable
                draggable
                order={tile.order}
                focused={hoveredTileID === tile.id}
                isImgSelected={isTileSelected(tile)}
                toggleSelected={() => onToggleTile(tile)}
                onImageClick={() => onZoomTile(tile.id)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
